// @flow
import invariant from 'invariant';
import * as React from 'react';

type Context = {
  values: Object,
  getValue: string => mixed,
  updateValue: (name: string, value: any, callback?: Function) => void,
  updateValues: (update: Object) => void,
  updateValueWith: (
    name: string | $ReadOnlyArray<string>,
    updater: Function,
    callback?: Function
  ) => void,
  setFetchingAddress: boolean => void,
  errors: APIErrors,
  setErrors: APIErrors => void,
  clearErrors: (?Array<string>) => void,
  submitting: boolean,
  updateSubmitting: boolean => void,
  submitDisabled: boolean,
  updateSubmitDisabled: boolean => void,
  fieldQaIdPrefix: ?string,
  edited: boolean,
  handleError: (error: Object, updatedFormData: ?Object) => void
};

const FormContext = React.createContext<?Context>();

export const FormContextProvider: React.ComponentType<{
  value: ?Context,
  children?: React.Node
}> = FormContext.Provider;

export const FormContextConsumer = ({
  children
}: {
  children: Context => React.Node
}) => (
  <FormContext.Consumer>
    {value => {
      invariant(value, 'Missing FormContext value');
      return children(value);
    }}
  </FormContext.Consumer>
);

export default FormContext;
